import { Component, h, Prop, Listen } from '@stencil/core';
@Component({
  tag: 'back-to-top',
  styleUrl: 'back-to-top.css',
  shadow: true,
})
export class BackToTop {
  @Prop({ mutable: true, reflect: true }) isActive = false;

  @Prop() right: string = '22px';           // PC: X方向定位
  @Prop() bottom: string = '140px';         // PC: Y方向定位
  @Prop() right_m: string = '20px';         // MB: X方向定位
  @Prop() bottom_m: string = '70px';        // MB: Y方向定位

  @Listen('scroll', { target: 'window' })
  handleScroll() {
    requestAnimationFrame(() => {
      this.isActive = window.pageYOffset > 800
    })
  }

  private ScrollToSmoothly(pos: number, time: number): void {
    const currentPos = window.pageYOffset;
    let start = null;
    if (time == null) time = 500;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      var scrollTo = (pos < currentPos ? Math.max(currentPos - progress / time * (currentPos - pos), pos) :
        Math.min(currentPos + progress / time * (pos - currentPos), pos));
      window.scrollTo(0, scrollTo);
      if (progress < time) {
        requestAnimationFrame(step);
      }
    }
    requestAnimationFrame(step);
  }

  private handleClick = () => {
    this.ScrollToSmoothly(0, 300)
  }

  render() {
    return (
        <div
          id="btn-back-to-top"
          class={{
            'active': this.isActive
          }}
          onClick={this.handleClick}
          style={{
            '--right': this.right, 
            '--bottom': this.bottom,
            '--right_m': this.right_m, 
            '--bottom_m': this.bottom_m
          }}
        >
          <svg class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M546.133333 989.955038C546.133333 1008.757555 530.982741 1024 512 1024L512 1024C493.148672 1024 477.866667 1008.94976 477.866667 989.954423L477.866667 113.1079 208.787627 382.186974C195.54246 395.432107 174.092083 395.456341 160.669252 382.03351L160.669252 382.03351C147.339332 368.703625 147.262293 347.168631 160.850807 333.580117L482.354586 12.076339C488.903817 5.527142 501.924659 0 511.168614 0 522.10374 0 534.958797 5.406754 541.628382 12.076339L863.13216 333.580117C876.56233 347.010287 876.736546 368.610679 863.313715 382.03351L863.313715 382.03351C849.983829 395.363396 828.400674 395.392273 815.19674 382.188373L546.133333 113.124932 546.133333 989.955038Z">
            </path>
          </svg>
        </div>
    );
  }
}
